import { defineSchema } from '../../schema-meta.ts';
import { registerSchema } from '../../generic-codec.ts';

export const StageWaveSchema = defineSchema({
  name: 'stageWave',
  fields: [
    ['waveNumber', 'number'],
    ['killGoal', 'number'],
    ['timeLimitSeconds', 'number'],
    ['silverReward', 'number'],
    ['shopConfigId', 'number?'],
    ['enemies', { kind: 'array', of: 'stageWaveEnemy' }],
  ],
  lookupKeys: ['waveNumber'],
});

registerSchema(StageWaveSchema);
